module.exports = __webpack_public_path__ + "img/s4.e8b9bec5.jpg";